export default "__VITE_ASSET__2ee3004b__"